//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function createLeadService(lead) {
    try {
        await api.post("/leads", lead);
        toast.success("Lead adicionado com sucesso");
        return true;
    } catch {
        toast.error("Erro ao salvar lead");
        return false;
    }
}